$(document).ready(function () {
	resetAnimationSizes()

	const animatedElements = $('.animated-hero__part')

	animatedElements.hover(
		function () {
			const thisElementId = $(this).data('anim-el')
			$(this).addClass('active')

			animatedElements.each(function (i, el) {
				if ($(el).data('anim-el') !== thisElementId) {
					$(el).css('flex-basis', el.dataset.minsize)
					$(el).addClass('fadeout')
				}
			})

			$(this).css('flex-grow', '1')
		},
		function () {
			animatedElements.each(function (i, el) {
				$(el).css('flex-basis', '')
				$(el).removeClass('fadeout')
				$(el).removeClass('active')
			})

			$(this).css('flex-grow', '')
		}
	)

	$(window).on('resize', resetAnimationSizes)
})

function resetAnimationSizes() {
	const animatedElements = $('.animated-hero__part')

	const fixatedElements = $('.animated-hero__inner')

	fixatedElements.css('height', 'auto')
	fixatedElements.css('width', 'auto')

	requestAnimationFrame(reconfigureAnimationSizes)
}

function reconfigureAnimationSizes() {
	const animatedElements = $('.animated-hero__part')

	const fixatedElements = $('.animated-hero__inner')

	const maxHeight = Math.max(
		...fixatedElements.map(function () {
			return $(this).height()
		})
	)

	fixatedElements.height(maxHeight)
	animatedElements.css('min-height', '95vh')

	fixatedElements.each(function (i, el) {
		const currentWidth = $(el).width()
		$(el).width(currentWidth)
		$(el).next().find('.animated-hero__links').width(currentWidth)
	})

	animatedElements.each(function (i, el) {
		let minSize = $(el).find('h3').width()
		el.setAttribute('data-minsize', 'calc(' + minSize + 'px + 6rem)')
	})
}
